import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button, Popover, Overlay } from 'react-bootstrap';
import Icon2 from 'components/media/Icon2/index.js';

const StyledButton = styled(Button)`
  height: 18px;
  padding-top: 0;
  padding-bottom: 0;
`;

const Wrapper = styled.div`
  max-height: calc(50vh);
  overflow-y: auto;
`;

function InfoButton(props) {
  const { className = 'ps-2 opacity-50', popoverClassName = 'text-muted text-center', placement = 'top', children, okMessage } = props;
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(false);
  const targetRef = setTarget;
  const handleHide = () => setShow(false);
  return (
    <>
      <StyledButton variant="link" size="sm" className={className} ref={targetRef} onClick={() => setShow(true)}>
        <Icon2 className="ss-info fs-4 text-info" />
      </StyledButton>
      {target && (
        <Overlay
          show={show}
          onHide={handleHide}
          container={this}
          rootClose
          placement={placement}
          target={target}
        >
          <Popover id="pages-popover">
            <Popover.Body className={popoverClassName}>
              <Wrapper>
                {children}
              </Wrapper>
              {okMessage && <Button className="mt-3" variant="primary" size="sm" onClick={handleHide}><FormattedMessage {...okMessage} /></Button>}
            </Popover.Body>
          </Popover>

        </Overlay>
      )}
    </>
  );
}

InfoButton.propTypes = {
  className: PropTypes.string,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  children: PropTypes.node.isRequired,
  popoverClassName: PropTypes.string,
  okMessage: PropTypes.object,
};

export default InfoButton;
